<template>
    <div class="setting-style-height d-flex flex-column justify-content-center">
        <div class="w-100 pb-2 d-flex align-items-center">
            <label
                for="styleHeight"
                class="font-14 m-0"
            >
                Tamanho Vertical do Item
            </label>

            <div class="ml-3 d-flex justify-content-center align-items-center">
                <button id="deslock" v-if="isLockStyleHeight" @click="handlerUnlockStyleHeight">
                    <i class="fal fa-lock font-14"></i>
                </button>

                <button id="lock" v-else @click="handlerLockStyleHeight">
                    <i class="fal fa-lock-open font-14"></i>
                </button>
            </div>
        </div>

        <div class="row no-gutters">
            <input
                class="col-2 form-control" 
                type="number"
                id="styleHeightInput"
                name="styleHeightInput"
                v-model="styleHeight"
                :min="minValue"
                :max="maxValue"
                :disabled="isLockStyleHeight"
            />

            <select
                id="styleHeightMetric"
                name="styleHeightMetric"
                class="col-2"
                style="color: #495057; cursor: not-allowed;"
                v-model="metricActive"
                disabled
            >
                <option
                    v-for="metric in metrics"
                    :key="metric.id"
                    :value="metric.value"
                >
                    {{ metric.label }}
                </option>
            </select>

            <input
                id="styleHeightRange"
                name="styleHeightRange"
                class="col px-2"
                type="range"
                :max="maxValue"
                :min="minValue"
                v-model="styleHeight"
                :disabled="isLockStyleHeight"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'SettingFrameStyleHeight',
    props: {
        item: {
            type: Object,
            required: true
        },
        hasFullHeight: {
            type: Boolean,
            required: false
        },
    },
    data() {
        return {
            styleHeight: 0,
            minValue: 10,
            maxValue: 800,
            metrics: [
                {
                    id: 1,
                    value: 'px',
                    label: 'px',
                },
                {
                    id: 2,
                    value: '%',
                    label: '%',
                },
                {
                    id: 3,
                    value: 'vh',
                    label: 'vh',
                }
            ],
            metricActive: null,
        }
    },
    methods: {
        onChangeStyleHeight() {
            this.$emit('onChangeStyleHeight', this.item)
        },
        handlerLockStyleHeight() {
            this.$emit('onChangeStyleHeightLock', true);
        },
        handlerUnlockStyleHeight() {
            this.$emit('onChangeStyleHeightLock', false);
        },
    },
    computed: {
        isLockStyleHeight() {
            return !!this.item.extra.style_height_lock;
        },
    },
    watch: {
        styleHeight() {
            const styleHeight = `${this.styleHeight}px`;

            this.$emit('onChangeStyleHeight', styleHeight);
        },
    },
    created() {
        this.metricActive = this.item.extra.style.height.replace(/[0-9]/g, '');

        this.styleHeight = this.item.extra.style.height.replace(this.metricActive, '');
    },
}
</script>

<style scoped>
/********** Range Input Styles **********/
/*Range Reset*/
input[type="range"] {
   -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
    width: 15rem;
}

/* Removes default focus */
input[type="range"]:focus {
  outline: none;
}

/***** Chrome, Safari, Opera and Edge Chromium styles *****/
/* slider track */
input[type="range"]::-webkit-slider-runnable-track {
   background-color: var(--main-color);
   border-radius: 0.5rem;
   height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none; /* Override default look */
   appearance: none;
   margin-top: -12px; /* Centers thumb on the track */

   /*custom styles*/
   background-color: var(--main-color);
   height: 2rem;
   width: 2rem;
   border-radius: 50%;
}

input[type="range"]:focus::-webkit-slider-thumb {   
  border: 1px solid var(--main-color);
  outline: 3px solid var(--main-color);
  outline-offset: 0.125rem; 
}

/******** Firefox styles ********/
/* slider track */
input[type="range"]::-moz-range-track {
   background-color: var(--main-color);
   border-radius: 0.5rem;
   height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-moz-range-thumb {
   /*custom styles*/
   background-color: var(--main-color);
   height: 2rem;
   width: 2rem;
}

input[type="range"]:focus::-moz-range-thumb {
  border: 1px solid var(--main-color);
  outline: 3px solid var(--main-color);
  outline-offset: 0.125rem; 
}

#deslock, #lock {
    background: transparent;
    border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/atoms/SettingFrameStyleHeight.vue